// extracted by mini-css-extract-plugin
export default {"container":"dr-z","heading":"er-z","text":"fr-z","info":"gr-z","link":"hr-z","fullMaxWidth":"ir-z"};